import { render, staticRenderFns } from "./beginCourseList.vue?vue&type=template&id=0abb2215&scoped=true&"
import script from "./beginCourseList.vue?vue&type=script&lang=js&"
export * from "./beginCourseList.vue?vue&type=script&lang=js&"
import style0 from "./beginCourseList.vue?vue&type=style&index=0&id=0abb2215&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abb2215",
  null
  
)

export default component.exports